export enum IconPack {
  Material = 'material',
  MaterialCommunity = 'materialCommunity', // TODO: Remove, unused
  CustomImage = 'customImage',
  Eva = 'eva',
}
